import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { delete_labelset_label } from '../assets/constants/global_apis';

const SubLabelList = ({ editLabelSublabels, seteditLabelSublabels, handleAddSubLabelSave, openAlertPopup, label, index, handleGetCollectionLabelsetDetails }) => {
  const [sublabelData, setSublabelData] = useState([]);
  const [addingNew, setAddingNew] = useState(false);
  const [newLabel, setNewLabel] = useState({
    label: '',
    description: ''
  });

  useEffect(() => {
    let sublabels = [...label.labels.map((item, indx) => ({
      label: item.labelName || '',
      description: item.labelDescription || ''
    }))];
    setSublabelData(sublabels);
  }, [label, index]);

  const handleChange = (i, field, value) => {
    const updated = [...sublabelData];
    updated[i][field] = value;
    setSublabelData(updated);
  };

  const handleSave = () => {
    const sublabelDataCopy = addingNew ? [...sublabelData, newLabel] : [...sublabelData];
    for (let i = 0; i < sublabelDataCopy.length; i++) {
      if (!sublabelDataCopy[i].label || !sublabelDataCopy[i].description) {
        openAlertPopup("Error", "Error", "Label and Description cannot be empty.");
        return;
      }
    }

    let updatedSublabels = [...sublabelDataCopy.map((item) => item.label)];
    let updatedSublabelsDescription = [...sublabelDataCopy.map((item) => item.description)];

    updatedSublabels = typeof updatedSublabels === 'string' ? [updatedSublabels] : updatedSublabels;
    updatedSublabelsDescription = typeof updatedSublabelsDescription === 'string' ? [updatedSublabelsDescription] : updatedSublabelsDescription;

    seteditLabelSublabels((prev) => ({
      ...prev,
      labels: updatedSublabels,
      description: updatedSublabelsDescription,
      editable: false,
    }));
    setAddingNew(false);
    handleAddSubLabelSave({
      ...editLabelSublabels,
      labels: updatedSublabels,
      description: updatedSublabelsDescription,
      editable: false,
    });
    setNewLabel({
      label: '',
      description: ''
    });
  };

  const handleCancel = () => {
    seteditLabelSublabels({
      editable: false,
      labels: [],
      description: [],
      editIndex: 0,
    });
    setAddingNew(false);
    setNewLabel({
      label: '',
      description: ''
    });
  };
  const handleLabelDelete = (labelId) => {
    delete_labelset_label(labelId).then((response) => {
      if (response.status == 'success') {
        openAlertPopup("Success", "Success", "Label deleted successfully.");
        handleGetCollectionLabelsetDetails();
      } else {
        openAlertPopup("Error", "Error", "Failed to delete label.");
      }
    }).catch((error) => {
      openAlertPopup("Error", "Error", "An error occurred while deleting the label.");
    });
  };

  const labelsTable = () => (
    <table className="sublabel-table">
      <thead>
        <tr>
          <th className='left-cells'>Label</th>
          <th className='right-cells'>Description</th>
          <th className='right-cells'>Remove</th>
        </tr>
      </thead>
      <tbody>
        {label.labels.map((sublabel, index1) => (
          <tr key={`label${index}sublabels${index1}`}>
            <td className='left-cells' title={sublabel.labelName}>{sublabel.labelName}</td>
            <td className='right-cells' title={sublabel.labelDescription}>{sublabel.labelDescription || 'No description'}</td>
            <td className='right-cells text-center text-danger cursor-pointer' title={"Delete Label"} onClick={() => handleLabelDelete(sublabel.id)}><FontAwesomeIcon icon={faTrash} /></td>
          </tr>
        ))}
      </tbody>
    </table>)

  if (!(editLabelSublabels.editable && index === editLabelSublabels.editIndex)) {
    return (
      <>
        <div>
          {labelsTable()}
        </div>
        <div style={{ marginTop: '0.5rem' }}>
          {!addingNew && (
            <button className="btn btn-sm btn-outline-primary" onClick={() => {
              seteditLabelSublabels({
                ...editLabelSublabels,
                editable: true,
                editIndex: index
              });
              setAddingNew(true);
            }}>
              <FontAwesomeIcon icon={faPlus} /> Add New Label
            </button>
          )}
        </div>
      </>
    );
  }

  return (
    <div className="sublabel-edit-wrapper">
      <div>
        {addingNew && labelsTable()}
      </div>

      {!addingNew && sublabelData.map((item, i) => (
        <div className="d-flex sublabel-row mb-2" key={i}>
          <input
            className="form-control me-2"
            type="text"
            placeholder="Label"
            value={item.label}
            onChange={(e) => handleChange(i, 'label', e.target.value)}
          />
          <input
            className="form-control"
            type="text"
            placeholder="Description"
            value={item.description}
            onKeyDown={(event) => event.key=="Enter" && handleSave()}
            onChange={(e) => handleChange(i, 'description', e.target.value)}
          />
        </div>
      ))}


      {addingNew && (
        <table className='sublabel-table'>
          {/* <tr>
              <th colSpan={2} className='left-cells' style={{textAlign:'center'}}>Add New Label</th>
            </tr> */}
          <tr>
            <td className='left-cells'>
              <input
                className="form-control me-2"
                type="text"
                placeholder="Label"
                value={newLabel.label}
                onChange={(e) => {
                  setNewLabel({ ...newLabel, label: e.target.value });
                }}
              />
            </td>
            <td className='right-cells'>
              <input
                className="form-control"
                type="text"
                placeholder="Description"
                value={newLabel.description}
                onKeyDown={(event) => event.key=="Enter" && handleSave()}
                onChange={(e) => {
                  setNewLabel({ ...newLabel, description: e.target.value });
                }}
              />
            </td>
          </tr>
        </table>
      )}

      <div className="editControllContainer mt-3">
        <button className='editCancel' onClick={handleCancel}>
          <FontAwesomeIcon icon={faTimes} /> Cancel
        </button>
        <button className='editSave' onClick={handleSave}>
          <FontAwesomeIcon icon={faCheck} /> Save
        </button>
      </div>
    </div>
  );
};

export default SubLabelList;